import { Button, Typography } from '@mui/material';
import togglerIcon from 'assets/img/icon-toggler.svg';
import classNames from 'classnames';
import RoamingProduct from 'components/RoamingProduct';
import useLocalizedData from 'hooks/useLocalizedData';
import { ROAMING_SHOP_URL, TRAVEL_PASS_URL } from './RoamingProducts.consts';
import ROAMING_PRODUCTS_LABELS from './RoamingProducts.labels';
import styles from './RoamingProducts.module.scss';
import useRoamingProducts from './useRoamingProducts';

const RoamingProducts = ({ productsInfo, isCountrySelected = false }) => {
  const [labels] = useLocalizedData(ROAMING_PRODUCTS_LABELS);
  const { mainPlan, visiblePlans, hasPlans, hasMorePlans, outerColClass, colClass, showAll, toggleShowAll } =
    useRoamingProducts(productsInfo, labels);

  if (!mainPlan && !hasPlans) {
    return undefined;
  }
  return (
    <div className={styles.container}>
      <div
        className={classNames('row g-4', {
          'align-items-start': showAll,
          'align-items-stretch': !showAll,
        })}
      >
        {mainPlan && (
          <div className="col-12 col-xl-4">
            <div className={styles.group}>
              <Typography component="div" variant="h5" className="pb-3">
                {labels?.['mainPlanTitle']}
              </Typography>
              <div className="row gx-3 gy-4 justify-content-start align-items-stretch h-100">
                <div className="col-12">
                  <RoamingProduct plan={mainPlan} hideFromLabel={isCountrySelected} redirectUrl={TRAVEL_PASS_URL} />
                </div>
              </div>
            </div>
          </div>
        )}
        {hasPlans && (
          <div className={outerColClass}>
            <div className={styles.group}>
              <Typography component="div" variant="h5" className="pb-3">
                {labels?.['plansTitles']}
              </Typography>
              <div className="row gx-3 gy-4 justify-content-start align-items-stretch h-100">
                {visiblePlans.map((it, id) => (
                  <div className={colClass} key={id}>
                    <RoamingProduct plan={it} hideFromLabel={isCountrySelected} redirectUrl={ROAMING_SHOP_URL} />
                  </div>
                ))}
                {hasMorePlans && (
                  <div className={classNames('col-12', styles.toggleCol)}>
                    <div className="d-flex align-items-center justify-content-center w-100 mt-2">
                      <Button variant="text" className={styles.toggleButton} onClick={toggleShowAll} disableRipple>
                        {showAll ? labels?.['showLess'] : labels?.['showMore']}
                        <img
                          src={togglerIcon}
                          alt=""
                          style={{
                            transform: showAll ? 'rotate(180deg)' : 'rotate(0deg)',
                            transition: 'transform 0.2s',
                          }}
                        />
                      </Button>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default RoamingProducts;
